import React, { Component } from "react";
import * as pr from "../../../common/PrimeComponents";

import { FlowItemListDiagram } from "./FlowItemListDiagram";

export class FlowVisual extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //Loading
      loaded: false,
      editLoaded: true
    };
  }

  render() {
    return (
      <div>
        <p>Flow Visualisation</p>
        <pr.Messages ref={el => (this.messages = el)}></pr.Messages>

        <div className="ui-g-12">
          <div class="ui-g-6"></div>
          <div className="ui-g-6"></div>
          <div className="ui-g-12">
            <FlowItemListDiagram
              flowBean={this.props.flowBean}
              fullComponentList={this.props.fullComponentList}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Flows/UI/FlowVisual.js